import {AFFILIATE_STORE} from '../actions';

/**
 * @method  affiliateStore
 * @param   {object} state  The current state
 * @param   {object} action The action to be performed
 * @returns {object} Returns the new state object
 */
export default function affiliateStore(state = {}, action) {
  switch (action.type) {
    case AFFILIATE_STORE:
      return {...action.data};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/redux/reducers/affiliateStore.js